import axios from 'axios';

// Create axios instance with base config
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '/gw',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request middleware
apiClient.interceptors.request.use(
    (config) => {
        // You can modify requests here (add auth tokens, etc.)
        const token = localStorage.getItem('authToken');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        // Add language header from wherever you store it
        const language = localStorage.getItem('i18nextLng') || 'en';
        config.headers['Accept-Language'] = language;
        config.headers['X-Tenant-ID'] = 'Main-Page';

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response middleware
apiClient.interceptors.response.use(
    (response) => {
        // You can modify successful responses here
        return response;
    },
    (error) => {
        // Handle errors globally
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // Handle unauthorized
                    break;
                case 404:
                    // Handle not found
                    break;
                case 500:
                    // Handle server error
                    break;
                default:
                // Handle other errors
            }
        }
        return Promise.reject(error);
    }
);

export default apiClient;
